'use client';

import { useContext, useEffect, useState } from 'react';
import { VoiceAxiosContext, VoiceAxiosReadyContext } from '@/app/components/VoiceAxios';
import { fetchCallbacks } from '@/services/sageVoiceApi';

const REFRESH_MS = 60_000;
const FETCH_LIMIT = 100;

/**
 * Number of callbacks still waiting on the team (status `pending`), for the Calls badge.
 * Polls only while `enabled` (a Voice route and the user may view callbacks); a failed
 * fetch leaves the previous count rather than flashing the badge off.
 */
export function usePendingCallbackCount(
  enabled: boolean,
  refreshKey?: string
): number {
  const voiceAxios = useContext(VoiceAxiosContext);
  const voiceReady = useContext(VoiceAxiosReadyContext);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled || !voiceReady) {
      setCount(0);
      return;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const rows = await fetchCallbacks(
          { status: 'pending', limit: FETCH_LIMIT },
          voiceAxios
        );
        if (!cancelled) setCount(rows.length);
      } catch {
        /* keep previous count */
      }
    };
    void load();
    const id = setInterval(load, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [enabled, refreshKey, voiceAxios, voiceReady]);

  return count;
}
